import React from 'react';
import Spinner from '../../images/loading-gif.gif';

export const SpinnerDiv = ({ show }) => (
    <>
        { show &&
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                width: '100%',
                height: '100%',
                background: '#f1f1f1',
                opacity: 0.4,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 999
            }}>
                <img style={{ position: 'absolute' }} src={Spinner} alt="Loadinf..." />
            </div>

        }
    </>
);
